import { createFileRoute } from "@tanstack/react-router";
import CauseDetail from "@project/donate/pages/checkout/$kind.$id";

export const Route = createFileRoute("/donate/c/$kind/$id")({
  head: () => ({ meta: [{ title: "Donate — Jivandhara" }] }),
  component: CauseDetail,
});
